import React from 'react'
import Media from './common/Media'
import useLink from '../hooks/useLink'
import { log } from '../data/logs'
import { NavLink } from 'react-router-dom'
import { Logo } from './imports'

const Logs = () => {
  return (
    <div className='grid grid-cols-2 lg:grid-cols-3 gap-6 w-full relative'>
      {log.map((item, i) => {
        return (
          <LogItem
            key={i}
            {...item}
            i={i}
          />
        )
      })}
    </div>
  )
}


const LogItem = ({ i, company }) => {

  const prLink = useLink();

  return (
    <article className='relative group flex min-h-20 min-w-20 drop-shadow-lg= shadow-2xl= aspect-[4/5] max-h-[800px] hover:z-[20]'>

      <Logo className={"absolute inset-3 m-auto z-0"} />
      <div className='w-full h-full relative group-hover:p-1 p-0 group-hover:bg-white group-hover:scale-105 brightness-80 group-hover:brightness-100 group-hover:translate-y-2 origin-bottom !quicker'>
        <NavLink to="#" /* to={`/log/${prLink(company)}`} */>
          <Media src={require(`../assets/log/log - ${prLink(company)}.jpg`)} />
        </NavLink>
      </div>
    </article>
  )
}
export default Logs